import { cn } from "@productlane/lib/src/browser"

interface IProps {
	className?: string
	text?: string
}

export function Divider({ className, text, ...props }: IProps) {
	return (
		<div className={cn(className, "my-2 flex w-full items-center")} {...props}>
			<div className="grow border-t" aria-hidden="true" />
			{text && <div className="mx-3 grow-0 text-xxs opacity-50">{text}</div>}
			<div className="grow border-t" aria-hidden="true" />
		</div>
	)
}
